import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { NAV, STUDIO_INFO } from '@/constants/studio'

export const StageFooter: FC = (): ReactNode => {
    const year = 2026

    return (
        <footer className='border-t border-white/10'>
            <div className='mx-auto grid max-w-[1200px] gap-10 px-6 py-14 sm:grid-cols-2 sm:px-10 lg:grid-cols-4'>
                <div className='lg:col-span-2'>
                    <span className='inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.3em]'>
                        <i aria-hidden className='text-xs not-italic opacity-80'>✳</i>
                        {STUDIO_INFO.mark}
                    </span>

                    <p className='mt-4 max-w-[34ch] font-heading text-2xl leading-[1.15] text-[#F4F1EA]/80'>
                        {STUDIO_INFO.line}. One gel, one figure, ten years of it.
                    </p>
                </div>

                <div>
                    <h2 className='text-[10px] font-medium uppercase tracking-[0.3em] text-[#F4F1EA]/45'>
                        Studio
                    </h2>

                    <address className='mt-4 space-y-1 text-[13px] leading-relaxed text-[#F4F1EA]/65 not-italic'>
                        {STUDIO_INFO.address.map((line) => (
                            <span key={line} className='block'>
                                {line}
                            </span>
                        ))}

                        <a
                            href={`mailto:${STUDIO_INFO.email}`}
                            className='mt-3 block underline-offset-4 transition-colors hover:text-[#F4F1EA] hover:underline'
                        >
                            {STUDIO_INFO.email}
                        </a>

                        <a
                            href={`tel:${STUDIO_INFO.phone.replace(/\s/g, '')}`}
                            className='block underline-offset-4 transition-colors hover:text-[#F4F1EA] hover:underline'
                        >
                            {STUDIO_INFO.phone}
                        </a>
                    </address>
                </div>

                <div>
                    <h2 className='text-[10px] font-medium uppercase tracking-[0.3em] text-[#F4F1EA]/45'>
                        Elsewhere
                    </h2>

                    <ul className='mt-4 space-y-2 text-[13px] text-[#F4F1EA]/65'>
                        {NAV.map((link) => (
                            <li key={link.href}>
                                <Link
                                    href={link.href}
                                    className='underline-offset-4 transition-colors hover:text-[#F4F1EA] hover:underline'
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}

                        {STUDIO_INFO.social.map((link) => (
                            <li key={link.label}>
                                <a
                                    href={link.href}
                                    className='underline-offset-4 transition-colors hover:text-[#F4F1EA] hover:underline'
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className='mx-auto flex max-w-[1200px] flex-col gap-2 border-t border-white/10 px-6 py-6 text-[10.5px] uppercase tracking-[0.22em] text-[#F4F1EA]/40 sm:flex-row sm:items-center sm:justify-between sm:px-10'>
                <span>
                    © {year} {STUDIO_INFO.mark} Studio
                </span>

                <span>
                    {STUDIO_INFO.hours}
                </span>
            </div>
        </footer>
    )
}
